import { EntityRequestEntmt } from "../../entity/EntityRequestEntmt";

export class DtoRequestEntmtsPutRes extends EntityRequestEntmt {}
